$(document).ready(function () {
  new ResizeObserver(() => {
    const logoHeight = $("#logo-bar").height();
    $(".overlay-header").css("margin-top", `-${Math.ceil(logoHeight)}px`);
  }).observe(document.querySelector("#logo-bar"));
});
